import { render, staticRenderFns } from "./DataMigration.vue?vue&type=template&id=d392ea7e&scoped=true&lang=pug&"
import script from "./DataMigration.vue?vue&type=script&lang=js&"
export * from "./DataMigration.vue?vue&type=script&lang=js&"
import style0 from "./DataMigration.vue?vue&type=style&index=0&id=d392ea7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d392ea7e",
  null
  
)

/* custom blocks */
import block0 from "./DataMigration.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports